import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
// import uni from './assets/js/uni.webview.1.5.2.js'

if (environment.production) {
  enableProdMode();
  window.console.log = function(){};
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));


// document.addEventListener("UniAppJSBridgeReady", function() {
//   document.getElementById("uni-navigate-back").onclick = function() {
//     console.log(uni)
//     setTimeout(() => {
//       uni.switchTab({
//         url: '/pages/memberMain/index',
//         complete() {
//           uni.navigateTo({
//             url: '/pages/memberMain/myRewards/myRewards'
//           })
//         }
//       })
//     }, 200)
//   };
// });
